export default __webpack_public_path__ + "static/media/whatsapp.12125e0c.png";